// extracted by mini-css-extract-plugin
export default {"root":"BodyScroll_root__6EYTm","row":"BodyScroll_row__71d9S"};